import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getCMAApiClient } from "../../apis/comps/cma/api-factories";
import { buildGetCmaPresentationEditQueryKey } from "./useGetCmaPresentationEdit";

type Props = {
  onSuccess?: () => void;
  onError?: (error: any, params: Params) => void;
};

type Params = {
  cmaId: string;
  formData: FormData;
};

export const useUploadSubjectPropertyPhotos = (props?: Props) => {
  const { onSuccess, onError } = props || {};
  const api = getCMAApiClient();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      const { cmaId, formData } = params;
      const response = await api.cMAControllerAddSubjectPropertyPhoto({
        id: cmaId,
        images: formData.getAll("images") as Blob[],
      });

      setTimeout(() => {
        queryClient.invalidateQueries({
          queryKey: buildGetCmaPresentationEditQueryKey(cmaId),
        });
      }, 1500);

      onSuccess?.();
      return response;
    },
    onError: async (error, params) => {
      console.error(
        `Failed to upload CMA photos with id ${params.cmaId}`,
        error,
      );
      onError?.(error, params);
    },
  });

  return mutation;
};
